var Handlebars = require('/opt/atlassian/pipelines/agent/build/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h1 class=\"text-center m-b-40\">Bookmarks</h1>\n<div id=\"bb-bookmarks-sub-page-content-region\"></div>\n";
},"useData":true});